import React from 'react';
import createReactClass from 'create-react-class';
import SearchComponent from './components/search';
import Datalist from '../datalist/datalist';

let dList;
let container;

function start() {
	container = document.query('.slx-search--header');
	const notActiveInput = document.query('.slx-search--header:not(.active) .slx-search__input');

	if (container) {
		dList = new Datalist({
			el: container,
			resultsSelector: '.slx-search__results',
			component: SearchComponent
		});
		dList.start();
		dList.events.on('openLayout', onOpenLayout);
		dList.events.on('closeLayout', onCloseLayout);

		notActiveInput.addEventListener('click', onNotActiveInputClick);
	}
}

function onNotActiveInputClick(event) {
	event.preventDefault();
	dList.openLayout();
}

function onOpenLayout() {
	if (!dList.getValue() && dList.getLastSearch()) {
		dList.setValue(dList.getLastSearch());
	}
	dList.focus();
}

function onCloseLayout() {
	// Fix Firefox => time out
	setTimeout(() => dList.setValue(''), 0);
}

start();
